<template>
  <div>
    <div
      class="venue-title-bar"
      :style="pageTitleBar"
    >
      <div class="venue-title">
        RESULTS
      </div>

      <div
        v-if="uploadedImageName"
        class="venue-image"
      >
        <img
          :src="uploadedImagePath"
          alt=""
        >
      </div>

      <div class="the-time">
        {{ theTime }}
      </div>
    </div>

    <Ticker />

    <div class="flex-race-container">
      <div
        v-for="race in screenData"
        :key="race.index"
        class="flex-race-item"
        :class="{ noedge:race.index%3 === 0 }"
      >
        <div
          class="race-title-bar"
          :style="raceTitleBar"
        >
          <div class="race-venue-flag">
            <!-- <img v-bind:src="flagImage(venue.countryName)" alt=""> -->
          </div>

          <div class="race-venue-name">
            <div class="venue-name">
              {{ venueDisplayName(race.ve) }}
            </div>

            <div class="race-name">
              {{ race.fn | race }} - {{ race.raceDateTime | satime }}
            </div>
          </div>
        </div>

        <div class="markets-container">
          <ResultMarket :race="race" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import venuemixin from '../mixins/venuemixin';
import ResultMarket from '@/components/ResultMarket';
import Ticker from '@/components/Ticker';

export default {
  name: 'Venue',
  components: {
    ResultMarket,
    Ticker
  },
  filters: {
    race: function(input) {
      if (input !== null && input !== undefined) {
        input = 'Race ' + input.substring(input.indexOf('.R'), input.length).replace('.R0', '').replace('.R', '');
      }
      return input;
    }
  },
  mixins: [venuemixin],
  data() {
    return {
      theTime: ''
    };
  },
  computed: {
    screenData() {
      return this.$store.state.screenData;
    },
    venueDate() {
      if (this.screenData[0].venueDate !== undefined) {
        return moment(this.screenData[0].venueDate).add(2, 'hours').format('YYYY-MM-DD');
      }

      return '';
    },
    marketContainerHeightVenue() {
      return this.$store.getters.marketContainerHeightVenue;
    },
    pageTitleBar() {
      return this.$store.getters.pageTitleBar;
    },
    raceTitleBar() {
      return this.$store.getters.raceTitleBar;
    },
    uploadedImagePath() {
      return `${this.$store.state.webUrl}/uploads/${this.$store.state.screenConfig.uploadedImageName}`;
    },
    uploadedImageName() {
      return this.$store.state.screenConfig.uploadedImageName;
    }
  },
  created: function() {
    setInterval(() => {
      this.theTime = moment.utc().add(2, 'hours').format('HH:mm:ss');
      this.$store.commit('updateSaNow', moment.utc().format('YYYY-MM-DDTHH:mm:ss') + '.000Z');
    }, 1000);

    setInterval(() => {
      this.refresh();
    }, 60000);
  },
  methods: {
    flagImage(countryName) {
      if (countryName) {
        return `${this.$store.state.screensUrl}/static/img/${countryName.toLowerCase().replace(' ', '-')}.png`;
      }

      return '';
    },
    venueDisplayName(displayname) {
      if (displayname) {
        return displayname.replace('$VE ', '').trim().toUpperCase();
      }

      return '';
    }
  }
};
</script>

<style scoped>
.flex-race-container {
  display: flex;
  flex-wrap: wrap;
}
.flex-race-item {
  flex-basis: 33.33333333%;
  border-right: 1px solid #000;
}
.venue-title-bar {
  display: flex;
  flex-direction: row;
  height: 64px;
  font-size: 40px;
  font-weight: bold;
}
.country-flag {

}
.venue-title {

  line-height: 64px;
  padding-left: 10px;
}
.the-time {
  flex-grow: 1;
  align-content: flex-end;
  line-height: 64px;
  padding-right: 10px;
  width: 160px;
  text-align: right;
}
.race-title-bar {
  background-color: #fb2e01;
  color: white;
  font-size: 24px;
  height: 64px;
  font-weight: bold;
}
.race-venue-flag {
  float: left;
  height: 64px;
}
.race-venue-name {
  float: left;
  margin-left: 10px;
  max-width: 225px;
  overflow: hidden;
  white-space: nowrap;
}
.race-name {
  line-height: 25px;
}
.race-container-container {
  width: 100%;
}
.noedge {
  border-right: 0;
}
.race-titles {
  float: right;
  color: #fff;
  text-align: center;
}
.race-places-paid {
  float: right;
  color: #fff;
  text-align: right;
  font-size: 12px;
  line-height: 64px;
  margin-left: 0;
}
.price-title {
  float: right;
  font-size: 10px;
  font-size: 14px;
  line-height: 64px;
  width: 90px;
}
.prev-title {
  float: right;
  font-size: 14px;
  line-height: 64px;
  width: 70px;
}
.place-title {
  float: right;
  font-size: 14px;
  line-height: 64px;
  width: 70px;
}
.venue-image {
  flex-grow: 1;
  align-content: flex-end;
  text-align: right;
}
.venue-image img {
  height: 64px;
}
</style>



// WEBPACK FOOTER //
// Results.vue?270d251d